// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"191":"7c1a3892","350":"081b2839","361":"7c1a3892","830":"0b6b4907"}[chunkId] + ".css";
};